/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");


const pop = require('components/base/pop/pop');
const plugMixin = require('./plugMixin');
const template = require('./plugDetail.tpl');
require('./plugDetail.scss');

const plugDetail = {
	mixins:[plugMixin],
	template,
	data(){
		return {
			detailData:{},
			spotData:{
					score:4.6
			}
		}
	}
}

module.exports = plugDetail;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/preview/plug/plugDetail/plugDetail.js